import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import {Link, useNavigate} from "react-router-dom";
import {imageExists, projectName, projectshortCode, toTitleCase} from "../../../resources/constants";
import Loader from "../../common/loader/loader";
import PageHeader from "../../common/pageheader/pageheader";
import {
    setCourseFeesData,
    setMinAmountAllowData,
    setOtherFeesData, setPaymentHistoryData, setScholarshipData,
    setWalletData
} from "../../../actions/actions";

const PaymentDashboard = (props) => {
    const [currentWallet, setCurrentWallet] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const userData = props.userData;
    const token = userData.token;
    const navigate = useNavigate();

    useEffect(() => {
        getPaymentData();
        // // Add class when component mounts
        //  document.body.classList.add("mini-sidebar");
        //
        // // Remove class when component unmounts
        // return () => {
        //     document.body.classList.remove("mini-sidebar");
        // };
    }, []);

    const getPaymentData = async () => {
        const sendData = {
            student_id: userData.student_id,
            course_code: userData.course_code,
            student_level: userData.student_level,
            student_semester: userData.student_semester,
            app_type: userData.app_type,
        };

        try {
            const res = await axios.post(`${serverLink}payment/dashboard`, sendData, token);
            if (res.data.message === "success") {
                console.log(res.data)
                const wallet = parseInt(res.data.wallet);
                setCurrentWallet(wallet);
                props.setOnWalletDataDetails(wallet);
                props.setOnCourseFeeDataDetails(res.data.course_fee);
                props.setOnOtherFeesDataDetails(res.data.other_fee);
                props.setOnScholarshipDataDetails(res.data.scholarship);
                props.setOnPaymentHistoryDataDetails(res.data.payment_history);
                setIsLoading(false);
            }
        } catch (error) {
            console.error("ERROR FETCHING RECORD", error);
        }
    };

    const currencyConverter = (amount) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "NGN",
        }).format(amount);
    };

    return (
        <div>
            {isLoading ? (
                <Loader/>
            ) : (
                <>
                    <PageHeader
                        title={"Payment Dashboard"}
                        items={["Payment","Dashboard"]}
                    />
                    <div className="row mb-2">
                        <div className="col-md-12">
                            <div className="card bg-dark position-relative">
                                <div className="card-body">
                                    <div className="d-flex mb-3">
                                        <div className="avatar avatar-xxl rounded flex-shrink-0 me-3">
                                            <img src={ imageExists(`${serverLink}public/uploads/${projectshortCode}/application/document/${userData.student_id}`) ? `${serverLink}public/uploads/${projectshortCode}/application/document/${userData.student_id}` : require('../../images/user.png')} alt="Img"/>
                                            {/*<img src="assets/img/students/student-13.jpg" alt="Img"/>*/}
                                        </div>
                                        <div className="d-block">
                                            <span className="badge bg-transparent-primary text-primary mb-1" style={{fontSize: '16px'}}>{userData.app_type === "student" ? userData.student_id : `APP ID: ${userData.student_id}`}</span>
                                            <h3 className="text-truncate text-white mb-1">{userData.student_name}</h3>
                                            <div className="d-flex align-items-center flex-wrap row-gap-2 text-gray-2">
                                                <span className="border-end me-2 pe-2">{toTitleCase(userData.course_name)}</span>
                                                <span className="border-end me-2 pe-2">{userData.student_level} Level</span>
                                                <span>{toTitleCase(userData.student_semester)} Semester</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between profile-footer flex-wrap row-gap-3 pt-4">
                                        <div className="d-flex align-items-center">
                                            <span className="badge bg-success d-inline-flex align-items-center ms-2"><i className="ti ti-circle-filled fs-5 me-1"></i>Active</span>
                                        </div>
                                        {/*<a href="edit-student.html" className="btn btn-primary">Edit Profile</a>*/}
                                    </div>
                                    <div className="student-card-bg">
                                        <img src={require('../../images/bg/circle-shape.png')} alt="Bg"/>
                                        <img src={require("../../images/bg/shape-02.png")} alt="Bg"/>
                                        <img src={require("../../images/bg/shape-04.png")} alt="Bg"/>
                                        <img src={require("../../images/bg/blue-polygon.png")} alt="Bg"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card  border-3 border-white text-center p-3">
									<span className="avatar avatar-sm rounded bg-success mx-auto mb-3">
										<i className="ti ti-currency-dollar fs-30"></i>
									</span>
                                <h6 className="mb-2">Outstanding Balance</h6>
                                <h2 className="mb-2">{currencyConverter(currentWallet)}</h2>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card  border-3 border-white text-center p-3">
									<span className="avatar avatar-sm rounded bg-success mx-auto mb-3">
										<i className="ti ti-currency-dollar fs-30"></i>
									</span>
                                <h3 className="mb-2">Pay Now</h3>
                                <Link className="btn btn-success-light" to="/portal/payment/pay-now"><i className="fa fa-money-bill me-2"></i> Pay Now</Link>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <h1 className="text-center">Payment Guide</h1>
                                <p className="text-center">Read below the instructions on how to use this platform</p>
                                <ul className="timeline">
                                    <li>
                                        <div className="timeline-badge success">
                                            <i className="fas fa-hand-holding-dollar"></i>
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="timeline-title"><span className="text-success fw-bold fs-3">1. </span>Click on Pay Now</h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p>To start of our payment application process, click on the pay now from the button above or from the navigation bar</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="timeline-inverted">
                                        <div className="timeline-badge warning">
                                            <i className="fas fa-file-invoice-dollar"></i>
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="timeline-title"><span className="text-success fw-bold fs-3">2. </span>On the payment page </h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p>Select the Tuition or Other Fees tab to select the item</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="timeline-badge danger">
                                            <i className="fas fa-file-excel"></i>
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="timeline-title"><span className="text-success fw-bold fs-3">3. </span> Tuition</h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p>Select the tuition item you what to pay for. For instance, under tuition section, you can select tuition for one semester or session</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="timeline-inverted">
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="timeline-title"><span className="text-success fw-bold fs-3">4. </span>Other fees</h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p>Under other fees, you can select payment for Hostel, Feeding, ID Card, Laundry, etc.</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="timeline-badge info">
                                            <i className="fa fa-save"></i>
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="timeline-title"><span className="text-success fw-bold fs-3">5. </span>Finally</h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p>Enter the amount you want to pay and click "Validate Payment Button"</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="timeline-inverted">
                                        <div className="timeline-badge success">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="timeline-title"><span className="text-success fw-bold fs-3">6. </span>Online Payment</h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p>Click on pay now button which will pop up a Paystack payment gateway. You can make payment using Card, Bank, or USSD options. PS: There is a 300 Naira processing fee from the Paystack platform</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.paymentLoginDetails,
    }

};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnWalletDataDetails: (p) => {
            dispatch(setWalletData(p));
        },
        setOnCourseFeeDataDetails: (p) => {
            dispatch(setCourseFeesData(p));
        },
        setOnOtherFeesDataDetails: (p) => {
            dispatch(setOtherFeesData(p));
        },
        setOnMinAmountAllowDataDetails: (p) => {
            dispatch(setMinAmountAllowData(p));
        },
        setOnScholarshipDataDetails: (p) => {
            dispatch(setScholarshipData(p));
        },
        setOnPaymentHistoryDataDetails: (p) => {
            dispatch(setPaymentHistoryData(p));
        },
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(PaymentDashboard);
